<body class="horizontal-layout horizontal-menu 1-column  bg-full-screen-image blank-page blank-page"
    data-open="hover" data-menu="horizontal-menu" data-col="1-column">
    <!-- BEGIN: Content-->

    <!-- BEGIN: Header-->
    <nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-static-top navbar-dark navbar-border navbar-brand-center">
        <div class="navbar-wrapper">
            <div class="navbar-container container center-layout">
                <div class="collapse navbar-collapse" id="navbar-mobile">
                    <ul class="nav navbar-nav mr-auto float-left">
                        <li class="nav-item">
                            <a class="" href="javascript:void(0)">
                                <img class="brand-logo logo" src="/assets/images/logo-light.svg">
                            </a>
                        </li>
                    </ul>
                    <ul class="nav navbar-nav float-right">
                        <li class="nav-item">
                            <a class="nav-link" href="http://mathecad.com/">
                                <i class="feather icon-home"></i>
                                <span>Home</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="http://mathecad.com/about-us/">
                                <i class="feather icon-globe"></i>
                                <span>About Us</span>
                            </a>
                        </li>
                        <!-- <i class="feather icon-globe"></i> -->
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="http://mathecad.com/our-story/">
                                <span>Our Story</span>
                            </a>
                        </li> -->
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="http://mathecad.com/levels/">
                                <i class="feather icon-book-open"></i>
                                <span>Levels</span>
                            </a>
                        </li> -->
                        <li class="nav-item">
                            <a class="nav-link" href="http://mathecad.com/pricing/">
                                <i class="feather icon-credit-card"></i>
                                <span>Pricing</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="http://mathecad.com/practokit/">
                                <i class="feather icon-book-open"></i>
                                <span>Practokit</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="http://mathecad.com/contact-us/">
                                <i class="feather icon-phone"></i>
                                <span>Contact Us</span>
                            </a>
                        </li>
                        <li class="nav-item ml-1">
                            <a class="nav-link nav-link-action" href="javascript:void(0)" [routerLink]="['/signup']" >
                                <i class="feather icon-user"></i>
                                <span>Signup to your Account</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
    <!-- END: Header-->

    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">
                <section class="row flexbox-container">
                    <div class="col-12 d-flex align-items-center justify-content-center">
                        <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
                            <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
                                <div class="card-header border-0 pb-0">
                                    <div class="card-title text-center">
                                        <img src="/assets/images/logo-dark.svg" alt="branding logo">
                                        <br><br>
                                    </div>
                                </div>
                                <div class="card-content">
                                    <p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1">
                                    <span>Enter Your logins</span></p>
                                    <div class="card-body">
                                        <form class="form-horizontal">
                                            <fieldset class="form-group position-relative has-icon-left mb-0">
                                                <input type="email" class="form-control" id="user-email" name="user-email" placeholder="Your Email Address" [(ngModel)]="email" required (keyup.enter)="Login()">
                                                <div class="form-control-position">
                                                    <i class="feather icon-mail"></i>
                                                </div>
                                            </fieldset>
                                            <fieldset class="form-group position-relative has-icon-left">
                                                <input [type]="visible? 'text':'password'" class="form-control" id="user-password" name="user-password" placeholder="Enter Password" [(ngModel)]="password" required (keyup.enter)="Login()">
                                                <div class="form-control-position">
                                                    <i class="fa fa-key"></i>
                                                </div>
                                                <div class="formControlPositionIconRight"
                                                    (click)="visible = !visible">
                                                    <i *ngIf="visible" class="fa fa-eye"></i>
                                                    <i *ngIf="!visible" class="fa fa-eye-slash"></i>
                                                </div>
                                            </fieldset>
                                            <button type="button" class="btn btn-outline-primary btn-block" (click)="Login()">
                                                <i class="feather icon-unlock"></i>
                                                Login
                                            </button>
                                            <div class="form-group row mt-2">
                                                <div class="col-sm-6 col-12 text-center text-sm-left pr-0">
                                                    <a href="javascript:void(0)" [routerLink]="['/signup']" class="card-link">New Account ?</a>
                                                </div>
                                                <div class="col-sm-6 col-12 float-sm-left text-center text-sm-right">
                                                    <a href="javascript:void(0)" [routerLink]="['/forgot-password']" class="card-link">Forgot Password</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <!-- END: Content-->

</body>
